import { render, staticRenderFns } from "./ui-option.vue?vue&type=template&id=fa56024a&"
import script from "./ui-option.vue?vue&type=script&lang=js&"
export * from "./ui-option.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports